import { FormattedMessage } from 'react-intl';

import { PremiumTagShell } from './premium-tag-shell';
import shellStyle from './premium-tag-shell.module.css';
import { WalmartSimplifiedShippingLogo } from './walmart-simplified-shipping-logo';
import { WALMART_COLOR } from './walmart-constants';
import { messages } from './messages';

export const WalmartSimplifiedShippingTag = () => {
  return (
    <PremiumTagShell color={WALMART_COLOR} logo={<WalmartSimplifiedShippingLogo className={shellStyle['tag-logo']} />}>
      <FormattedMessage {...messages.walmartSimplifiedShippingLabel} />
    </PremiumTagShell>
  );
};
